import { connect } from 'react-redux';
import KeepUrlFragment from './KeepUrlFragment';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default connect(mapStateToProps, null)(KeepUrlFragment);
